import axios from "axios";
import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
	width: "100%",
	"& > * + *": {
	  marginTop: theme.spacing(1),
	},
  },
  fieldset: {
	"& .Mui-focused .MuiOutlinedInput-notchedOutline": {
	  borderColor: "#780F9E",
	},
	"& legend": {
	  fontSize: 16,
	},
  },
  ".MuiIconButton-root": {
	padding: "12px",
  },
}));

const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
};

const defaultOptions = [];

export default function FormAutocompleteSelect({
  tags,
  input,
  value: propValue,
  onChange,
  placeholder,
  label,
  helperText,
}) {
  const classes = useStyles();

  // Support both redux-form and regular props
  const effectiveValue = input && input.value !== undefined ? input.value : propValue || [];
  const effectiveOnChange = input && input.onChange ? input.onChange : onChange;

  const [options, setOptions] = React.useState(defaultOptions);
  const [value, setValue] = React.useState(effectiveValue);
  const [inputValue, setInputValue] = React.useState("");

  // Keep internal state in sync with prop value
  React.useEffect(() => {
	setValue(effectiveValue);
  }, [effectiveValue]);

  return (
	<div className={classes.root}>
	  <Autocomplete
		multiple
		limitTags={999}
		id="multiple-limit-tags"
		options={options}
		getOptionSelected={(option, value) =>
		  (value.group_tags ? value.group_tags : value) ===
		  (option.group_tags ? option.group_tags : option)
		}
		freeSolo
		value={value}
		inputValue={inputValue}
		onChange={(event, newValue) => {
		  setValue(newValue);
		  if (effectiveOnChange) {
			effectiveOnChange(newValue);
		  }
		}}
		onInputChange={(event, newInputValue) => {
		  setInputValue(newInputValue);
		}}
		getOptionLabel={(option) => (option.group_tags ? option.group_tags : option)}
		renderInput={(params) => (
		  <TextField
			{...params}
			className={classes.fieldset}
			onClick={(event) => {
			  event.stopPropagation();
			}}
			variant="outlined"
			label={label || ""}
			placeholder={placeholder}
			helperText={helperText}
		  />
		)}
		renderOption={(option) => {
		  return <div className="autocomplete-search">{option}</div>;
		}}
	  />
	</div>
  );
}
